import { useState } from 'react'

function ActionCenter() {
  const [message, setMessage] = useState('')

  const handleAction = (action: string) => {
    setMessage(`Action "${action}" triggered! (API integration coming in Phase 3)`)
    setTimeout(() => setMessage(''), 3000)
  }

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Action Center</h2>
      <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap', marginTop: '1rem' }}>
        <button
          onClick={() => handleAction('upload-sow')}
          style={{
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: 'none',
            background: '#2563eb',
            color: 'white',
            cursor: 'pointer',
            fontSize: '1rem',
          }}
        >
          Upload New SOW
        </button>
        <button
          onClick={() => handleAction('checkin')}
          style={{
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: 'none',
            background: '#059669',
            color: 'white',
            cursor: 'pointer',
            fontSize: '1rem',
          }}
        >
          Trigger Mid-Project Check-in
        </button>
        <button
          onClick={() => handleAction('pause')}
          style={{
            padding: '0.75rem 1.5rem',
            borderRadius: '8px',
            border: 'none',
            background: '#d97706',
            color: 'white',
            cursor: 'pointer',
            fontSize: '1rem',
          }}
        >
          Pause / Resume Project
        </button>
      </div>
      {message && (
        <div style={{ marginTop: '1rem', padding: '0.75rem', background: '#e0f2fe', borderRadius: '8px' }}>
          {message}
        </div>
      )}
    </div>
  )
}

export default ActionCenter
